export const URL_PARAMETERS = {
  COUNTRY: '',
  LANGUAGE: '',
  POLICY_NO: '',
  LOB: '',
  PARTNER: '',
  TYPE:'',
  CAPTCHA:''
};
